import { render, staticRenderFns } from "./address-book.vue?vue&type=template&id=05477d9f&scoped=true"
import script from "./address-book.vue?vue&type=script&lang=js"
export * from "./address-book.vue?vue&type=script&lang=js"
import style0 from "./address-book.vue?vue&type=style&index=0&id=05477d9f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05477d9f",
  null
  
)

export default component.exports